import type { Me } from '../types';

export type RoleProfile = 'unavailable' | 'oversight' | 'coordination' | 'care' | 'sales';
export function roleProfile(me?: Pick<Me, 'user' | 'verticals' | 'issue_verticals'> | null): RoleProfile {
  if (!me || me.user.issues_only || me.user.dispatch_only) return 'unavailable';
  if (me.user.intake_coordinator) return 'coordination';
  if (me.user.role === 'admin') return 'oversight';
  if (me.issue_verticals?.some(team => !me.verticals.some(crm => crm.id === team.id))) return 'care';
  return me.verticals.length ? 'sales' : 'unavailable';
}
export function defaultDashboardMode(profile: RoleProfile): 'care' | 'sales' {
  return profile === 'coordination' || profile === 'care' ? 'care' : 'sales';
}
export function defaultDayScope(profile: RoleProfile): 'team' | 'mine' {
  return profile === 'oversight' ? 'team' : 'mine';
}
export function dashboardPreferenceKey(userId: number, profile: RoleProfile): string {
  return `toyamacrm:dashboard:v2:${userId}:${profile}`;
}
export function workflowAccessKey(me?: Pick<Me, 'user' | 'verticals' | 'issue_verticals'> | null): string {
  // The same coordinator workflow can have admin or member permissions.
  // Separate cache entries on either security-role or grant changes too.
  return me ? JSON.stringify([me.user.role, roleProfile(me), me.verticals.map(v => v.id).sort((a, b) => a - b), (me.issue_verticals ?? []).map(v => v.id).sort((a, b) => a - b)]) : 'anonymous';
}
export const rolePresentation: Record<RoleProfile, { title: string; subtitle: string }> = {
  unavailable: { title: 'Work overview unavailable', subtitle: 'Use the navigation for your permitted work.' },
  oversight: { title: 'Team oversight', subtitle: 'Team pipeline, ownership cleanup and actionable triage — not a personal assignment queue.' },
  coordination: { title: 'Intake & coordination', subtitle: 'Meetings you booked, customer calls, open issues and enquiry intake. Sales ownership stays with the responsible salesperson.' },
  care: { title: 'Customer-care work', subtitle: 'Callbacks and open issues across explicitly granted support teams; CRM access remains separate.' },
  sales: { title: 'My customers & sales', subtitle: 'Your owned contacts, commercial opportunities, customer/deal lifecycle and assigned follow-ups in the selected CRM scope.' }
};
